var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignCenterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Filled",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,6H23a1,1,0,0,0,0-2H1A1,1,0,0,0,1,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,9a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19,19H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23,14H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenterIcon);
export default __webpack_public_path__ + "static/media/alignCenterIcon.a365b7f7302dadaed90b492bda17be17.svg";
export { ForwardRef as ReactComponent };